import { object, string } from "yup"

export const formSchema = object({
  password: string().required("This field is required"),
  password2: string().required("This field is required")
})
